import {
    ARCHIVE_ASSIGNMENT, ARCHIVE_ASSIGNMENT_SUCCESS, ARCHIVE_ASSIGNMENT_FAILURE,
    FETCH_ASSIGNMENT, FETCH_ASSIGNMENT_SUCCESS, FETCH_ASSIGNMENT_FAILURE,
    FETCH_ASSIGNMENTS, FETCH_ASSIGNMENTS_SUCCESS, FETCH_ASSIGNMENTS_FAILURE,
    FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS, FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_SUCCESS, FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_FAILURE,
    REMOVE_ASSIGNMENT, REMOVE_ASSIGNMENT_SUCCESS, REMOVE_ASSIGNMENT_FAILURE,
    SAVE_ASSIGNMENT, SAVE_ASSIGNMENT_SUCCESS, SAVE_ASSIGNMENT_FAILURE,
    CLEAR_ASSIGNMENT, EMPTY_ASSIGNMENTS, SET_ASSIGNMENT, UPDATE_ASSIGNMENTS, UPDATE_SEARCH_TERM
} from './constants';

import { ASSIGNMENT_STATES, ASSIGNMENT_STATUSES } from 'containers/AssignmentsPage/constants';

export const emptyAssignment = {
    name: '',
    instructions: '',
    beacons: [],
    contents: [],
    groups: [],
    userIds: [],
    users: [],
    startDate: null,
    dueDate: null,
    mandatory: false,
    requireLocation: false,
    requireSignature: false,
    signaturePrompt: '',
    recurrance: 'none',
    recurUntil: 'none',
    state: ASSIGNMENT_STATES.UNPUBLISHED,
    status: ASSIGNMENT_STATUSES.NO_PROGRESS
};

const initialState = {
    allAssignments: [],
    assignment: JSON.parse(JSON.stringify(emptyAssignment)),
    pageNumber: 0,
    pageSize: 25,
    hasMore: true,
    filterBy: '',
    searchTerm: '',
    sortBy: 'lastEdited',
    sortDirection: true,
    thumbnailToUpload: null,
    isFetching: false,
    isFetchingUsersInGroups: false,
    isSaving: false,
    error: {}
};

function assignmentsReducer(state = initialState, action) {
    switch(action.type) {
        case ARCHIVE_ASSIGNMENT:
            return Object.assign({}, state, {
                isSaving: true,
                error: {}
            });
        case ARCHIVE_ASSIGNMENT_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                allAssignments: action.data,
                assignment: JSON.parse(JSON.stringify(emptyAssignment))
            });
        case ARCHIVE_ASSIGNMENT_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case FETCH_ASSIGNMENT:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_ASSIGNMENT_SUCCESS:
            return Object.assign({}, state, {
                assignment: action.data
            });
        case FETCH_ASSIGNMENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_ASSIGNMENTS:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_ASSIGNMENTS_SUCCESS:
            let hasMore = true;
            if(action.data.length === 0) {
                hasMore = false;
            }
            return Object.assign({}, state, {
                allAssignments: state.allAssignments.concat(action.data),
                pageNumber: state.pageNumber + 1,
                hasMore: hasMore,
                isFetching: false
            });
        case FETCH_ASSIGNMENTS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error,
                hasMore: false
            });
        case FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS:
            return Object.assign({}, state, {
                isFetchingUsersForGroups: true,
                error: {}
            });
        case FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_SUCCESS:
            return Object.assign({}, state, {
                isFetchingUsersForGroups: false
            });
        case FETCH_USERS_IN_GROUPS_FOR_ASSIGNMENTS_FAILURE:
            return Object.assign({}, state, {
                isFetchingUsersForGroups: false,
                error: action.error
            });
        case REMOVE_ASSIGNMENT:
            return Object.assign({}, state, {
                isSaving: true
            });
        case REMOVE_ASSIGNMENT_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                assignment: JSON.parse(JSON.stringify(emptyAssignment))
            });
        case REMOVE_ASSIGNMENT_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case SAVE_ASSIGNMENT:
            return Object.assign({}, state, {
                isSaving: true,
                error: {}
            });
        case SAVE_ASSIGNMENT_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                assignment: action.data
            });
        case SAVE_ASSIGNMENT_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case CLEAR_ASSIGNMENT:
            return Object.assign({}, state, {
                assignment: JSON.parse(JSON.stringify(emptyAssignment))
            });
        case EMPTY_ASSIGNMENTS:
            return initialState;
        case SET_ASSIGNMENT:
            return Object.assign({}, state, {
                assignment: action.data
            });
        case UPDATE_ASSIGNMENTS:
            return action.data;
        case UPDATE_SEARCH_TERM:
            return Object.assign({}, state, {
                searchTerm: action.data
            });
        default:
            return state;
    }
}

export default assignmentsReducer;



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/store/reducers.js